module.exports = __webpack_public_path__ + "media/images/common-nav/national-parks/yellowstone_national_park-fadd664745c3932641aa75cf92f793a6.jpg";